<template>
  <div class="item-view">
    <div class="flex flex-col flex-grow items-start justify-between px-4">
      <input
        type="text"
        :value="item ? item.name : 'Item not found'"
        class="p-2 w-full mr-2 flex-grow text-xl font-bold"
        @change="updateItemProperty($event, 'name')"
      >
      <p
        v-if="item"
        class="helper"
      >Edit description below...</p>
      <textarea
        class="relative w-full bg-transparent px-2 border mt-2 h-64 border-none leading-normal"
        :value="item ? item.description : 'No item with this ID'"
        @change="updateItemProperty($event, 'description')"
      />
      <button
        v-if="item"
        @click="deleteItem(item.id)"
        class="delete-item"
      >Delete Item</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getItem"]),
    item() {
      return this.getItem(this.$route.params.id);
    },
  },
  methods: {
    updateItemProperty(e, key) {
      var value = e.target.value.trim();

      if (value === "" && key === "name") {
        return;
      }

      this.$store.commit("UPDATE_ITEM", {
        item: this.item,
        key,
        value: value,
      });
    },
    deleteItem(itemId) {
      if (confirm("Are you sure you want to delete this item?")) {
        this.$store.commit("DELETE_ITEM", itemId);
        this.$router.push({ name: "list" });
      }
    },
  },
};
</script>

<style>
.item-view {
  @apply relative flex flex-row bg-white pin mx-4 m-32 mx-auto py-4 text-left rounded shadow;
  max-width: 700px;
  width: 90%;
  border-radius: 10px;
}

.helper {
  padding: 8px;
  color: darkgray;
  cursor: default;
}

.delete-item {
  cursor: pointer;
  color: white;
  background-color: tomato;
  margin-right: auto;
  font-weight: 500;
  font-size: 18px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 9px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-top: 10px;
  margin-left: 5px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.delete-item:hover {
  background-color: rgb(250, 121, 99);
}
</style>
